import React, { useRef, useEffect, useState } from 'react';
import { ListItemButton,Avatar, Container, Typography, Grid2, Paper, Toolbar, CssBaseline, Box, Button, TextField, ListItem, ListItemIcon, ListItemText, Drawer, List, Collapse } from '@mui/material';
import SensorsIcon from '@mui/icons-material/Sensors';
import { FixedSizeList } from "react-window";
import HistoryChart from '../components/HistoryChart';
import { useNavigate, useLocation } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Card, CardContent, CardHeader, CardActions } from '@mui/material';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const containerStyle = {
  maxHeight: window.innerWidth < 500 ? '70vh' : '77vh', // 设置最大高度
  overflowY: 'auto', // 允许垂直滚动
  padding: '10px', // 添加内边距
};


const Row = ({ data, className, style , onClick, lastUpdated }) => { // 添加 lastUpdated 参数
    const timeSinceUpdate = Math.floor((Date.now() - lastUpdated) / 1000); // 计算更新时间
    return (
      <div style={style}>
        <ListItem button onClick={() => onClick()}>
          <Paper elevation={2} style={{ borderRadius: '8px', padding: '8px', width: '100%' }}>
            <Grid2 container alignItems="center">
              <Grid2 item xs={2}>
                <ListItemIcon>
                  <Avatar variant="rounded" style={{backgroundColor:'#009999'}}>
                    <SensorsIcon />
                  </Avatar>
                </ListItemIcon>
              </Grid2>
              <Grid2 item>
                <ListItemText
                  primary={
                    <Typography 
                      variant="h6" 
                      style={{ color: (className === 'selected' ? 'lightblue' : (timeSinceUpdate > 605 ? 'grey':'inherit') )}} // 修改颜色
                    >
                      {data[1].name}
                    </Typography>
                  }
                />
              </Grid2>
            </Grid2>
          </Paper>
        </ListItem>
      </div>
    );
};
  
function SensorCard({ sensorId, data, lastUpdated, handleChartClickOpen }) {
const [timeSinceUpdate, setTimeSinceUpdate] = useState(0);


function gethumdity_ratio({temp_celsius,rh}){
    // constant
    const n1 = 0.11670521452767e+04
    const n2 = -0.72421316703206e+06
    const n3 = -0.17073846940092e+02
    const n4 = 0.12020824702470e+05
    const n5 = -0.32325550322333e+07
    const n6 = 0.14915108613530e+02
    const n7 = -0.48232657361591e+04
    const n8 = 0.40511340542057e+06
    const n9 = -0.23855557567849e+00
    const n10 = 0.65017534844798e+03
    const epsilon = 0.621945
    const air_pressure = 1009.01  // hPa, obtained from local weather station

    //Calculate θ
    const theta = (temp_celsius + 273.15) + n9 / ((temp_celsius + 273.15) - n10)
    
    // Calculate A, B, and C
    const A = theta ** 2 + n1 * theta + n2
    const B = n3 * theta ** 2 + n4 * theta + n5
    const C = n6 * theta ** 2 + n7 * theta + n8

    // Calculate the value of the expression inside the brackets
    const inner_expression = 2 * C / (-B + Math.sqrt(B ** 2 - 4 * A * C))

    // Calculate p_ws
    const p_ws = 10000 * inner_expression ** 4

    // Calculate saturation vapor pressure (Ps) in hPa
    const Ps = 6.11 * 10 ** ((7.5 * temp_celsius) / (237.3 + temp_celsius))

    // Calculate actual vapor pressure (E) in hPa
    const Pw = (rh / 100) * p_ws * 1

    // Calculate humidity ratio W in g/kg
    const W = epsilon * (Pw / (air_pressure - Pw)) * 1000

    return W
}

const humdity_ratio_scd = data.scd?gethumdity_ratio({temp_celsius:data.scd["4"]/100,rh:data.scd["5"]/100}):null

const humdity_ratio_sfa = data.sfa?gethumdity_ratio({temp_celsius:data.sfa["4"]/100,rh:data.sfa["5"]/100}):null

useEffect(() => {
    const interval = setInterval(() => {
    setTimeSinceUpdate(Math.floor((Date.now() - lastUpdated) / 1000));
    }, 1000);

    return () => clearInterval(interval);
}, [lastUpdated]);

const battery_low = (data.scd?.v <= 3.93)
const battery_low_low = (data.scd?.v <= 3.57)

const scd_co2_alarm = (data.scd?.["3"] > 1000)
const scd_temp_alarm = (data.scd?.["4"]/100 > 30) || (data.scd?.["4"]/100 < 15)
const scd_humdity_alarm = (data.scd?.["5"]/100 > 70) || (data.scd?.["5"]/100 < 30)
const scd_humdity_ratio_alarm = (humdity_ratio_scd > 10)

const scd_alarm = (scd_co2_alarm || scd_temp_alarm || scd_humdity_alarm || scd_humdity_ratio_alarm)

const sfa_hcho_alarm = (data.sfa?.["3"] > 200)
const sfa_temp_alarm = (data.sfa?.["4"]/100 > 30)
const sfa_humdity_alarm = (data.sfa?.["5"]/100 > 80)
const sfa_humdity_ratio_alarm = (humdity_ratio_sfa > 10)
const sfa_alarm = (sfa_hcho_alarm || sfa_temp_alarm || sfa_humdity_alarm || sfa_humdity_ratio_alarm)

const bmp_temp_alarm = (data.bmp?.["4"]/100 > 30)
const bmp_pressure_alarm = (data.bmp?.["5"]/100 > 100000)
const bmp_pressure_max_alarm = (data.bmp?.["6"]/100 > 100000)
const bmp_pressure_min_alarm = (data.bmp?.["7"]/100 < 100000)
const bmp_alarm = (bmp_temp_alarm || bmp_pressure_alarm || bmp_pressure_max_alarm || bmp_pressure_min_alarm)

const sps_pm1_alarm = (data.sps?.["0"]/100 > 20)
const sps_pm25_alarm = (data.sps?.["1"]/100 > 20)
const sps_pm4_alarm = (data.sps?.["2"]/100 > 20)
const sps_pm10_alarm = (data.sps?.["3"]/100 > 20)
const sps_nc05_alarm = (data.sps?.["4"]/100 > 250)
const sps_nc1_alarm = (data.sps?.["5"]/100 > 250)
const sps_nc25_alarm = (data.sps?.["6"]/100 > 250)
const sps_nc4_alarm = (data.sps?.["7"]/100 > 250)
const sps_nc10_alarm = (data.sps?.["8"]/100 > 250)
const sps_typical_size_alarm = (data.sps?.["9"]/100 > 10)

const sps_alarm = (sps_pm1_alarm || sps_pm25_alarm || sps_pm4_alarm || sps_pm10_alarm || sps_nc05_alarm || sps_nc1_alarm || sps_nc25_alarm || sps_nc4_alarm || sps_nc10_alarm || sps_typical_size_alarm)

return (
    <Grid2 item xs={12} sm={12} md={12}>
    <Paper elevation={12} style={containerStyle}>
      <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(min(300px, 100%), 1fr))" gap={1}>
      
          <Card variant="outlined" style={{ borderRadius: '8px', padding: '8px', borderColor:'#999999', backgroundColor:'#333333'}}>
            
              <CardContent padding={0}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize={18} variant="body1" noWrap pb={1}>Device</Typography>
                </Box>
                {(data?.name) ?
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize={14} variant="body1" noWrap>Name</Typography>
                  <Typography fontSize={14} variant="body1" noWrap>{data.name}</Typography>
                </Box>
                :null}

                {(sensorId) ?
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize={14} variant="body1" noWrap>MAC</Typography>
                  <Typography fontSize={14} variant="body1" noWrap>{sensorId.toUpperCase()}</Typography>
                </Box>
                :null}
                
                {(data?.scd?.w) ?
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize={14} variant="body1" noWrap>Uptime[hrs]</Typography>
                  <Typography fontSize={14} variant="body1" noWrap>{data.scd.w}</Typography>
                </Box>
                :null}
              

                {(data?.sps?.w) ?
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize={14} variant="body1" noWrap>WIFI Runtime[ms]</Typography>
                  <Typography fontSize={14} variant="body1" noWrap>{data.sps.w}</Typography>
                </Box>
                :null}

                {(data?.scd?.v) ?
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontSize={14} variant="body1" noWrap>Battery[V]</Typography>
                  <Typography fontSize={14} variant="body1" noWrap style={{ color: battery_low_low ? '#BB0000' : battery_low ? '#FFA500' : 'inherit' }}>{(data.scd.v / 1000).toFixed(3)}</Typography>
                </Box>
                :null}
              </CardContent>

          </Card>

        {data?.scd && (
        <Card variant="outlined" style={{ borderRadius: '8px', padding: '8px', borderWidth: '2px', borderColor: scd_alarm ? '#990000' : '#009999', backgroundColor: '#333333'}}>
          <CardContent>

            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={18} variant="body1" noWrap pb={1}>CO2 Sensor</Typography>
            </Box>

            {(data?.scd?.["3"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>CO2 [ppm]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: scd_co2_alarm ? '#BB0000' : 'inherit' }}>{data.scd["3"]}</Typography>
            </Box>
            :null}

            {(data?.scd?.["4"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Temperature [°C]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: scd_temp_alarm ? '#BB0000' : 'inherit' }}>{(data.scd["4"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.scd?.["5"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Humidity [%]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: scd_humdity_alarm ? '#BB0000' : 'inherit' }}>{(data.scd["5"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(humdity_ratio_scd) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Humidity Ratio [g/kg]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: scd_humdity_ratio_alarm ? '#BB0000' : 'inherit' }}>{humdity_ratio_scd.toFixed(2)}</Typography>
            </Box>
            :null}

          </CardContent>
        </Card>
        )}

        {data?.bmp && (
        <Card variant="outlined" style={{ borderRadius: '8px', padding: '8px', borderWidth: '2px', borderColor: bmp_alarm ? '#999999' : '#999999', backgroundColor: '#333333'}}>
          <CardContent>

            <Box display="flex" justifyContent="space-between" alignItems="center"> 
              <Typography fontSize={18} variant="body1" noWrap pb={1}>Pressure Sensor</Typography>
            </Box>

            {(data?.bmp?.["4"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Temperature [°C]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{(data.bmp["4"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.bmp?.["5"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Pressure [Pa]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{(data.bmp["5"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.bmp?.["6"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Max Pressure [Pa]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{(data.bmp["6"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.bmp?.["7"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Min Pressure [Pa]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{(data.bmp["7"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

          </CardContent>
        </Card>
        )}

        {data?.sfa && (
        <Card variant="outlined" style={{ borderRadius: '8px', padding: '8px', borderWidth: '2px', borderColor: sfa_alarm ? '#990000' : '#009999', backgroundColor: '#333333'}}>
          
          <CardContent>

            <Box display="flex" justifyContent="space-between" alignItems="center"> 
              <Typography fontSize={18} variant="body1" noWrap pb={1}>HCHO Sensor</Typography>
            </Box>

            {(data?.sfa?.["3"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>HCHO [ppb]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{data.sfa["3"]}</Typography>
            </Box>
            :null}

            {(data?.sfa?.["4"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Temperature [°C]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{(data.sfa["4"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sfa?.["5"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Humidity [%]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{(data.sfa["5"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(humdity_ratio_sfa) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Humidity Ratio [g/kg]</Typography>
              <Typography fontSize={14} variant="body1" noWrap>{humdity_ratio_sfa.toFixed(2)}</Typography>
            </Box>
            :null}

          </CardContent>
        </Card>
        )}

        {data?.sps && (
        <Card variant="outlined" style={{ borderRadius: '8px', padding: '8px', borderWidth: '2px', borderColor: sps_alarm ? '#990000' : '#009999', backgroundColor: '#333333'}}>
          
          <CardContent>

            <Box display="flex" justifyContent="space-between" alignItems="center"> 
              <Typography fontSize={18} variant="body1" noWrap pb={1}>PM Sensor</Typography>
            </Box>

            {(data?.sps?.["0"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>PM 1.0 [μg/m³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_pm1_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["0"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["1"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>PM 2.5 [μg/m³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_pm25_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["1"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["2"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>PM 4.0 [μg/m³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_pm4_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["2"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["3"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center" pb={1}>
              <Typography fontSize={14} variant="body1" noWrap>PM 10.0 [μg/m³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_pm10_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["3"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["4"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>NC 0.5 [#/cm³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_nc05_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["4"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["5"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>NC 1.0 [#/cm³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_nc1_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["5"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["6"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>NC 2.5 [#/cm³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_nc25_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["6"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["7"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>NC 4.0 [#/cm³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_nc4_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["7"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["8"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center" pb={1}>
              <Typography fontSize={14} variant="body1" noWrap>NC 10.0 [#/cm³]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_nc10_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["8"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

            {(data?.sps?.["9"]) ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize={14} variant="body1" noWrap>Typical particle size [μm]</Typography>
              <Typography fontSize={14} variant="body1" noWrap style={{ color: sps_typical_size_alarm ? '#BB0000' : 'inherit' }}>{(data.sps["9"] / 100).toFixed(2)}</Typography>
            </Box>
            :null}

          </CardContent>
        </Card>
        )}
        
        </Box>
      
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} pt={1} borderTop="1px solid #999999">
        <Typography fontSize={14} variant="body1" noWrap style={{ color: timeSinceUpdate > 605 ? 'red' : 'inherit', visibility: timeSinceUpdate === 0 ? 'hidden' : 'visible' }}>
            Updated: {timeSinceUpdate} seconds ago
        </Typography>
        <Button variant="contained" onClick={handleChartClickOpen}>
            History 
        </Button>
        </Box>
    </Paper>
    </Grid2>
);
}

const Sensors = ({userData, notification}) => {

  const location = useLocation(); // 使用 useLocation 钩子
  const state = location.state;

  const [sensorData, setSensorData] = useState({});
  const [lastUpdated, setLastUpdated] = useState({});
  const [selectedSensorId, setSelectedSensorId] = useState(''); // 新增状态以跟踪选中的传感器ID
  const [displayedRecords, setDisplayedRecords] = useState(null);
  const [buttonState, setButtonState] = useState('online');
  const [MenuOpen, setMenuOpen] = useState(false); // 新增状态以控制 Drawer
  const [drawerOpen, setDrawerOpen] = useState(false); // 新增状态以控制 Drawer
  const containerRef = useRef(null);
  const [openChart, setopenChart] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCompany, setFilterCompany] = useState('');
  const [filterArea, setFilterArea] = useState('');
  const [filterSite, setFilterSite] = useState('');

  const [open, setOpen] = useState(true);

  //console.log(sensorData)

  useEffect(() => {
    if (state?.notification){
        setSearchTerm(state?.notification ? state.notification : '');
        setButtonState(state?.notification ? 'offline' : 'offline');
        setDisplayedRecords(state?.notification ? Object.entries(sensorData).map(([sensorId]) => sensorId) : Object.entries(sensorData).map(([sensorId]) => sensorId));
    }
  }, [state?.notification]);
  
  const handleChartClickOpen = () => {
    setopenChart(true);
  };

  const handleChartClickClose = () => {
    setopenChart(false);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  
  const fetchLastRecord = async () => {
    try {
      const response = await fetch('/api/sensor/lastrecord');
      const data = await response.json();
      if (data.error){
        window.location.href = '/';
        return;
      }
      Object.entries(data).forEach(([sensorId, sensorData]) => {
        const currentTime = new Date(sensorData.timestamp).getTime();

        const SCDData = sensorData.SCD ? JSON.parse(sensorData.SCD) : null;
        const SFAData = sensorData.SFA ? JSON.parse(sensorData.SFA) : null;
        const SPSData = sensorData.SPS ? JSON.parse(sensorData.SPS) : null;
        const BMPData = sensorData.BMP ? JSON.parse(sensorData.BMP) : null;

        console.log(SFAData)

        if(sensorData.name != sensorData.deviceId){
          setSensorData(prevData => ({
            ...prevData,
            [sensorId]: { name: sensorData.name, sps: SPSData,scd: SCDData, sfa: SFAData, bmp: BMPData, ...sensorData } // 更新 SPS 数据
          }));
          setLastUpdated(prevData => ({
            ...prevData,
            [sensorId]: currentTime
          }));
        }else{
          console.log(sensorId + " Unloaded");
        }
      });
    } catch (error) {
      console.error('Error fetching last record:', error);
    }
  };

  useEffect(() => {
    fetchLastRecord();
    const interval = setInterval(fetchLastRecord, 5000); // 每30秒调用一次 fetchLastRecord
    return () => clearInterval(interval); // 清除定时器
  }, []);

  // derive unique hierarchy options from sensor data
  const allSensors = Object.values(sensorData);
  const companyOptions = [...new Map(allSensors.filter(d => d.company?._id).map(d => [d.company._id, d.company.name])).entries()].map(([id, name]) => ({ id, name }));
  const areaOptions = [...new Map(allSensors.filter(d => d.area?._id && (!filterCompany || d.company?._id === filterCompany)).map(d => [d.area._id, d.area.name])).entries()].map(([id, name]) => ({ id, name }));
  const siteOptions = [...new Map(allSensors.filter(d => d.site?._id && (!filterArea || d.area?._id === filterArea)).map(d => [d.site._id, d.site.name])).entries()].map(([id, name]) => ({ id, name }));

  // hierarchy filter function
  const passesHierarchyFilter = (data) => {
    if (filterCompany && data.company?._id !== filterCompany) return false;
    if (filterArea && data.area?._id !== filterArea) return false;
    if (filterSite && data.site?._id !== filterSite) return false;
    return true;
  };

 const filteredRecords = displayedRecords ? 
   (Object.entries(sensorData)
     .filter(([sensorId, data]) => data.name.includes(searchTerm))
     .filter(([sensorId, data]) => passesHierarchyFilter(data))
     .sort((a, b) => a[1].name.localeCompare(b[1].name))) // 按名称排序
   :
   (Object.entries(sensorData)
     .filter(([sensorId]) => 
       Object.entries(lastUpdated)
         .filter(([_, time]) => Math.floor(Date.now() - time) < 605 * 1000)
         .map(([sensorId]) => sensorId)
         .includes(sensorId))
     .filter(([sensorId, data]) => data.name.includes(searchTerm))
     .filter(([sensorId, data]) => passesHierarchyFilter(data))
     .sort((a, b) => a[1].name.localeCompare(b[1].name))); // 按名称排序
  return (
    <>
    {openChart && <HistoryChart sensorName={sensorData[selectedSensorId].name} sensorId={selectedSensorId} open={openChart} onClose={handleChartClickClose}/>}
      <CssBaseline />
      <Container ref={containerRef}>
        <Box paddingLeft={window.innerWidth > 500 ? 20 : 0} paddingRight={window.innerWidth > 500 ? 20 : 0}>
          <div style={{marginTop:'10px'}}/>
          <Paper elevation={3}>
          <List style={{marginTop:'0px'}}>
            <ListItemButton disabled={open} onClick={() =>setOpen(!open)}>
              <ListItemText primary="Search List" />
              {(selectedSensorId) && (open ? null : <ExpandMore />)}
            </ListItemButton>
            <Collapse in={open}>
              <ListItem>
              <TextField
                  style={{marginLeft:'10px',marginRight:'10px',marginTop:'10px'}}
                  variant="outlined"
                  placeholder="Search by Name"
                  value={searchTerm}
                  onChange={(e) => (
                      setButtonState(null),
                      setSearchTerm(e.target.value)              
                  )}
                  fullWidth // 修改为 fullWidth
                  InputProps={{
                    endAdornment: (
                      searchTerm && (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setSearchTerm('')}>
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                      )
                    ),
                  }}
                />
              </ListItem>

              {/* Hierarchy filter */}
              {companyOptions.length > 0 && (
              <ListItem style={{ paddingTop: 0 }}>
                <Box display="flex" gap={1} flexWrap="wrap" width="100%" px={1}>
                  <FormControl size="small" sx={{ minWidth: 100, flex: 1 }}>
                    <InputLabel>Company</InputLabel>
                    <Select value={filterCompany} label="Company" onChange={e => { setFilterCompany(e.target.value); setFilterArea(''); setFilterSite(''); }}>
                      <MenuItem value="">All</MenuItem>
                      {companyOptions.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <FormControl size="small" sx={{ minWidth: 100, flex: 1 }}>
                    <InputLabel>Area</InputLabel>
                    <Select value={filterArea} label="Area" onChange={e => { setFilterArea(e.target.value); setFilterSite(''); }} disabled={!filterCompany}>
                      <MenuItem value="">All</MenuItem>
                      {areaOptions.map(a => <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <FormControl size="small" sx={{ minWidth: 100, flex: 1 }}>
                    <InputLabel>Site</InputLabel>
                    <Select value={filterSite} label="Site" onChange={e => setFilterSite(e.target.value)} disabled={!filterArea}>
                      <MenuItem value="">All</MenuItem>
                      {siteOptions.map(s => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Box>
              </ListItem>
              )}

            <ListItem>
            <FixedSizeList
              height={375} // 设置列表高度
              itemSize={75} // 每个项的高度
              itemCount={filteredRecords.length} // 项的数量
              width="100%" // 列表宽度
            >
              {({ index, style }) => {
                const sensorId = filteredRecords[index][0]; // 获取传感器ID
                return (
                  <Row
                    style={style} 
                    onClick={() => {
                      setSelectedSensorId(sensorId);
                      handleDrawerOpen(); // 点击时打开 Drawer
                      setOpen(false)
                    }} 
                    className={selectedSensorId === sensorId ? 'selected' : ''} // 添加选中样式
                    data = {filteredRecords[index]}
                    lastUpdated={lastUpdated[sensorId]} // 传递 lastUpdated 参数
                  />
                );
              }}
            </FixedSizeList>
            </ListItem>

            <ListItem>
            <Button
              fullWidth
              variant="contained" 
              onClick={() => {
                if (buttonState === 'offline'){
                  setButtonState(null);
                  setDisplayedRecords(null);
                  return;
                }else{
                  setButtonState('offline'); // 设置选中的状态
                  setDisplayedRecords(Object.entries(sensorData).map(([sensorId]) => sensorId));
                  return;
                }
              }} // 仅显示在线传感器
              size="large"
            >
              {buttonState === 'offline' ? 'ONLINE ONLY' : 'SHOW ALL'}
            </Button>
          </ListItem>
          </Collapse>
          </List>
          </Paper>

          <div style={{marginTop:'10px'}}/>

          {(selectedSensorId && !open) && (
            <SensorCard 
              key={selectedSensorId} 
              sensorId={selectedSensorId} 
              data={sensorData[selectedSensorId]} 
              lastUpdated={lastUpdated[selectedSensorId]} 
              handleChartClickOpen={handleChartClickOpen}
            />
          )}
        </Box>
      <Box>
      </Box>
      </Container>
    </>
  );
};

export default Sensors;